module.exports = __webpack_public_path__ + "224baaa490e71122578b6052d7b76fc6.fbx";